module.exports = __webpack_public_path__ + "static/media/Gilroy-Medium.9e12d605.otf";